import { API } from "../store/index"
import handleCatch from "../lib/catch"

export const setChildParentRoles = (data = null) => ({
  type: "SET_CHILD_PARENT_ROLES",
  data,
})

export const getParentChildRoles = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/child_parent_roles`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setChildParentRoles(data))
            resolve(data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getParentChildRolesNoCount = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/child_parent_roles_fast`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setChildParentRoles(data))
            resolve(data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateParentRole = newRoleData => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/roles/${newRoleData.id}`)
          .send(newRoleData)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            resolve(data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createParentRole = newRoleData => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/parent_roles`)
          .send(newRoleData)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            resolve(data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const deleteParentRole = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/parent_roles/${id}`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(data => {
            resolve(data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const mergeSelectedRoles = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/merge_roles`)
          .send(data)
          .then(response => response.body)
          .then(data => {
            resolve(data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
